import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "Идентификаторы", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Тут больше ничего нет ")

import { usePermissions } from "@/use/usePermissions";
import { useIdentifiers } from "@/use/useIdentifiers";
import { useAsync } from "@/use/useAsync";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import UiIconBtn from "@/components/ui/UiIconBtn.vue";

import AppTabbar from "@/components/AppTabbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";

import AvailableServices from "../components/AvailableServices.vue";
import IdentifiersList from "../components/IdentifiersList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentifiersPage',
  setup(__props) {

const { isAllow, getDenyType } = usePermissions();
const { identifiers, services, fetchIdentifiers } = useIdentifiers();

const fetchData = useAsync(fetchIdentifiers, true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Идентификаторы"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(isAllow)('identifiers'))
        ? (_openBlock(), _createBlock(UiSuspense, {
            key: 0,
            failure: _unref(fetchData).isFailure.value,
            pending: _unref(fetchData).isPending.value,
            success: _unref(fetchData).isSuccess.value,
            variant: "screen",
            "has-retry": ""
          }, {
            default: _withCtx(() => [
              (_unref(services).length)
                ? (_openBlock(), _createBlock(AvailableServices, {
                    key: 0,
                    services: _unref(services)
                  }, null, 8, ["services"]))
                : _createCommentVNode("", true),
              (_unref(identifiers).length)
                ? (_openBlock(), _createBlock(IdentifiersList, {
                    key: 1,
                    identifiers: _unref(identifiers)
                  }, null, 8, ["identifiers"]))
                : _createCommentVNode("", true),
              (_unref(services).length || _unref(identifiers).length)
                ? (_openBlock(), _createBlock(UiCaption, {
                    key: 2,
                    level: "3",
                    style: {"text-align":"center"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["failure", "pending", "success"]))
        : (_unref(getDenyType)('identifiers') === 'unsupported')
          ? (_openBlock(), _createBlock(UiPlaceholder, {
              key: 1,
              icon: "CreditCard",
              title: "Модуль «Идентификаторы» недоступен",
              description: "К сожалению, модуль «Идентификаторы» не подключен к вашей школе."
            }))
          : (_unref(getDenyType)('identifiers') === 'subscription')
            ? (_openBlock(), _createBlock(UiPlaceholder, {
                key: 2,
                icon: "CreditCard",
                title: "Модуль «Идентификаторы» доступны по подписке",
                description: "Модуль «Идентификаторы» будет доступен после оформления расширенной подписки."
              }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})